import HTMLSanitizer from 'services/HTMLSanitizer';
import { get } from 'svelte/store';
import { searchPhrase } from './Search.store';
let fragment = get(searchPhrase).trim();
let fragmentLC = fragment.toLowerCase();
searchPhrase.subscribe(newPhrase => {
    fragment = HTMLSanitizer.escapeLtGtHtml(newPhrase.trim());
    fragmentLC = fragment.toLowerCase();
});
export function annotateFoundFragmentsInPhrase(phrase) {
    phrase = HTMLSanitizer.escapeLtGtHtml(phrase);
    const phraseLC = phrase.toLowerCase();
    if (fragmentLC.length === 0) {
        return phrase;
    }
    let lastIndex = -1;
    let builder = [];
    do {
        let nextOccurrence = phraseLC.indexOf(fragmentLC, lastIndex + 1);
        let endIndex = nextOccurrence;
        if (endIndex < 0) {
            endIndex = phrase.length;
        }
        builder.push(phrase.substring(lastIndex + 1, endIndex));
        lastIndex = endIndex;
        if (nextOccurrence >= 0) {
            builder.push("<strong>");
            builder.push(phrase.substring(lastIndex, lastIndex + fragmentLC.length));
            builder.push("</strong>");
            lastIndex += fragmentLC.length - 1;
        }
    } while (lastIndex < phrase.length);
    return builder.join('');
}
export function annotateFoundFragmentsInSimilarPhrase(similarPhrasesItem) {
    let phrase = similarPhrasesItem.phrase.trim();
    let emphStart = similarPhrasesItem.emphStart;
    let emphLength = similarPhrasesItem.emphLength;
    let emphasised = phrase.substring(emphStart, emphStart + emphLength).toLowerCase();
    phrase = HTMLSanitizer.escapeLtGtHtml(phrase);
    const phraseLC = phrase.toLowerCase();
    if (emphStart == -1 || emphasised.length === 0) {
        return phrase;
    }
    let lastIndex = -1;
    let builder = [];
    do {
        let nextOccurrence = phraseLC.indexOf(emphasised, lastIndex + 1);
        let endIndex = nextOccurrence;
        if (endIndex < 0) {
            endIndex = phrase.length;
        }
        builder.push(phrase.substring(lastIndex + 1, endIndex));
        lastIndex = endIndex;
        if (nextOccurrence >= 0) {
            builder.push("<strong>");
            builder.push(phrase.substring(lastIndex, lastIndex + emphasised.length));
            builder.push("</strong>");
            lastIndex += emphasised.length - 1;
        }
    } while (lastIndex < phrase.length);
    if (similarPhrasesItem.transliterated
        && similarPhrasesItem.transliterated.localeCompare(similarPhrasesItem.phrase) !== 0
        && fragmentLC !== emphasised
        && similarPhrasesItem.nonLatin) {
        let phrase = similarPhrasesItem.transliterated;
        let emphStart = similarPhrasesItem.emphTStart;
        let emphLength = similarPhrasesItem.emphTLength;
        builder.push("<div class=\"text-gray-500 text-xs\">");
        let emphasised = phrase.substring(emphStart, emphStart + emphLength).toLowerCase();
        phrase = HTMLSanitizer.escapeLtGtHtml(phrase);
        const phraseLC = phrase.toLowerCase();
        if (emphasised.length === 0) {
            return phrase;
        }
        let lastIndex = -1;
        do {
            let nextOccurrence = phraseLC.indexOf(emphasised, lastIndex + 1);
            let endIndex = nextOccurrence;
            if (endIndex < 0) {
                endIndex = phrase.length;
            }
            builder.push(phrase.substring(lastIndex + 1, endIndex));
            lastIndex = endIndex;
            if (nextOccurrence >= 0) {
                builder.push("<strong>");
                builder.push(phrase.substring(lastIndex, lastIndex + emphasised.length));
                builder.push("</strong>");
                lastIndex += emphasised.length - 1;
            }
        } while (lastIndex < phrase.length);
        builder.push("</div>");
    }
    return builder.join('');
}
